import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close-icon",
  "use": "icon-close-icon-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-close-icon\"><path d=\"M739.2 287c12.3 12.3 12.3 32.3 0 44.6L331.4 739.4c-12.3 12.3-32.3 12.3-44.6 0-12.3-12.3-12.3-32.3 0-44.6L694.6 287c12.3-12.3 32.3-12.3 44.6 0z\" fill=\"\" p-id=\"3604\" /><path d=\"M286.8 287c12.3-12.3 32.3-12.3 44.6 0l407.8 407.8c12.3 12.3 12.3 32.3 0 44.6-12.3 12.3-32.3 12.3-44.6 0L286.8 331.6c-12.3-12.3-12.3-32.3 0-44.6z\" fill=\"\" p-id=\"3605\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol